<template>
  <nav class="navbar is-danger">
    <div class="navbar-brand" style="width: 100%;">
      <div class="navbar-item is-size-5 has-text-weight-bold has-text-white">
        <b-icon icon="bars" class="burger-margin is-hidden-tablet"
                @click.native="is_open_menu =! is_open_menu"></b-icon>
        <router-link to="/" class="has-text-white">Twistock(β版)</router-link>
      </div>
      <a class="right is-danger has-text-white" v-if="!is_login" @click="login">
        ログイン
      </a>
      <b-dropdown aria-role="list" :mobile-modal="false" class="right is-right" v-if="is_login">
        <figure class="dropdown-trigger image is-32x32" slot="trigger">
          <img class="is-rounded" v-bind:src="icon_url">  <!-- twitterアイコン -->
        </figure>
        <b-dropdown-item aria-role="listitem" @click="logout">
          ログアウト
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <SideBar2 v-if="is_open_menu" class="has-background-light" @url-change="is_open_menu=false"/>
  </nav>
</template>

<script>
import firebase from '@/firebase'
import SideBar2 from '@/components/SideBar2.vue'

export default {
  components: {
    SideBar2
  },
  data() {
    return{
      is_open_menu: false,
    }
  },
  computed:{
    user_info: function () {
      let ret_info = this.$store.getters['getUserInfo']
      return JSON.parse(JSON.stringify(ret_info))
    },
    icon_url() {
      if(this.user_info.photoURL == ""){
        return "https://bulma.io/images/placeholders/32x32.png"
      }
      else{
        return this.user_info.photoURL
      }
    },
    is_login() {
      if(this.user_info.displayName == ""){
        return false
      }
      else{
        return true
      }
    },
    current_url() {
      return this.$route.path
    }
  },
  watch: {
    current_url() {
      this.is_open_menu = false
    }
  },
  methods:{
    login() {
      firebase.login()
    },
    logout() {
      firebase.logout()
      this.$router.push({path:'/'}).catch(()=>{})
    }
  }
}
</script>

<style>
.right {
  margin: auto 0.5em auto auto;
}
.burger-margin {
  padding-right: 1.5em;
  padding-left: 0.75em;
}
</style>